import { TransportNote } from './../model/transport-note';
import { Injectable } from '@angular/core';
import { Identity } from '@sdbn/appclient';
import { Observable } from 'rxjs';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { TransportDetails } from '../model/transport-details';
import { DocumentPreview } from '../model/document-preview';
import { PictureDocumentDetails } from '../model/picture-document-details';
import { AppDocumentDetails } from '../model/app-document-details';
import { RoutingPositionLog } from '../model/routing-position';
import { SupplementaryEquipment } from '@sdbn/appclient';
import { TransportDetailOption } from '../model/transport-detail-option';
import { TransportWeighing } from '../model/transport-weighing';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TransportDetailsService {

  constructor(private tmcHttpService: HttpService) { }

  public getTransportDetails(identity: Identity): Observable<TransportDetails> {
    return this.tmcHttpService.postWithContext<TransportDetails>(environment.transportDetailsEndpoint, identity);
  }

  public getRoutingPositionLogs(identity: Identity): Observable<RoutingPositionLog[]> {
    return this.tmcHttpService.postWithContext<RoutingPositionLog[]>(environment.transportDetailsEndpoint + '/log', identity).pipe(
      map(r => r.map(rp => new RoutingPositionLog(rp)))
    );
  }

  public getSupplementaryEquipment(identity: Identity): Observable<SupplementaryEquipment[]> {
    return this.tmcHttpService.postWithContext<SupplementaryEquipment[]>(environment.transportDetailsEndpoint + '/supplementary-equipment', identity);
  }

  public getTransportOptions(identity: Identity): Observable<TransportDetailOption[]> {
    return this.tmcHttpService.postWithContext<TransportDetailOption[]>(environment.transportDetailsEndpoint + '/transport-options', identity);
  }

  public getTransportWeighings(identity: Identity): Observable<TransportWeighing[]> {
    return this.tmcHttpService.postWithContext<TransportWeighing[]>(environment.transportDetailsEndpoint + '/transport-weighings', identity);
  }

  public getDocumentPreviews(identity: Identity): Observable<DocumentPreview[]> {
    return this.tmcHttpService.postWithContext<DocumentPreview[]>(environment.transportDetailsEndpoint + '/document-previews', identity);
  }

  addNote(note: TransportNote): Observable<void> {
    return this.tmcHttpService.postWithContext<void>(environment.transportDetailsEndpoint + '/add-note', note);
  }

  public getPictureDocumentDetails(preview: DocumentPreview): Observable<PictureDocumentDetails> {
    return this.tmcHttpService.postWithContext<PictureDocumentDetails>(environment.transportDetailsEndpoint + '/picture-document-details',
      preview.identifier
    );
  }

  public getAppDocumentDetails(preview: DocumentPreview): Observable<AppDocumentDetails> {
    return this.tmcHttpService.postWithContext<AppDocumentDetails>(environment.transportDetailsEndpoint + '/app-document-details',
      preview.identifier
    );
  }

  public createPrintout(transportIdentity: Identity) {

    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'weighing-printout');

    // keep focus in current window
    window.focus();

    const url = `${environment.transportDetailsEndpoint}/printout`;
    this.tmcHttpService.postWithArraybufferResponse<any>(url, transportIdentity).subscribe(result => {

      const file = new Blob([result], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

    }, error => {
      console.error(error);
    });
  }

}
